import {
  getTeamMemberAvatarColorClasses,
  getTeamMemberInitials,
} from "@/utils/team-member-avatar";

type TeamMemberInitialsAvatarSize = "sm" | "md";

const sizeClasses: Record<TeamMemberInitialsAvatarSize, string> = {
  sm: "size-7 text-[10px]",
  md: "size-9 text-xs",
};

interface TeamMemberInitialsAvatarProps {
  id: string;
  firstName: string;
  lastName: string;
  size?: TeamMemberInitialsAvatarSize;
  className?: string;
}

export function TeamMemberInitialsAvatar({
  id,
  firstName,
  lastName,
  size = "sm",
  className = "",
}: TeamMemberInitialsAvatarProps) {
  const initials = getTeamMemberInitials({
    first_name: firstName,
    last_name: lastName,
  });
  const colors = getTeamMemberAvatarColorClasses(id);

  return (
    <span
      aria-hidden
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-medium ${sizeClasses[size]} ${colors.bg} ${colors.text} ${className}`}
    >
      {initials}
    </span>
  );
}
